module.exports = __webpack_public_path__ + "img/handraw_quitter orange-46.4ad6c46d.svg";